export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["de"] = "de";
    LanguageCode["en"] = "en";
})(LanguageCode || (LanguageCode = {}));
